import script from "./SimpleDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleDropdown.vue?vue&type=script&setup=true&lang=js"

import "./SimpleDropdown.vue?vue&type=style&index=0&id=7116e566&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7116e566"]])

export default __exports__